export const RANKS = ["A", "B", "C", "D", "E"]?.map((label, id) => ({
  id: id + 1,
  label,
}));
